


export const CONSTANTES = {
  FECHA_CAMPANIA: "26/06/2026"
};